import { Flex, Image, Skeleton, Tag, Tooltip } from 'antd';

const SIZE_TO_HEIGHT_MAP = {
  xs: '1em',
  sm: '1.5em',
  md: '2em',
  lg: '2.5em',
  xl: '3em',
  xxl: '3.5em',
  full: '100%',
};

export const InsuranceCarrierLogo = ({
  name,
  logoUrl,
  height,
  width,
  size = 'md',
  disableTooltip = false,
  style,
}) => {
  const finalHeight = height ?? SIZE_TO_HEIGHT_MAP[size];

  return logoUrl
    ? (
      <Tooltip title={disableTooltip ? null : (name || 'Nombre no disponible')} mouseEnterDelay={0.5}>
        <Image
          src={logoUrl}
          alt={name || 'Aseguradora'}
          height={finalHeight}
          width={width}
          preview={false}
          style={{ objectFit: 'contain', ...style }}
          placeholder={
            <Flex justify='center' align='center'>
              <Skeleton.Node active style={{ height: finalHeight, width }} />
            </Flex>
          }
        />
      </Tooltip>
    ) : (
      <Tag style={{ marginRight: 0 }}>{name || 'Aseguradora desconocida'}</Tag>
    );
};

export default InsuranceCarrierLogo;